const appRouters: Array<any> = [{
    path: '/system',
    name: 'system',
    sort: 99,
    meta: { title: 'Menu.SystemSetting',icon: 'md-settings' },
    component: ()=>import('../shared/main/index.vue'),
    children: [
        { path: 'user',  meta: { title: 'Users',access:['Pages.Users'] }, name: 'user', component: () => import('./user/index.vue') },
        { 
            path: 'role',  meta: { title: 'Roles',access:['Pages.Roles'] ,defaultChild:'role.list'},name:'role', component: () => import('@/components/parent-view.vue'),
            children:[
                { path:'index',meta: { title: 'Roles',access:['Pages.Roles'],hideInMenu:true,hideInBread:true}, name:"role.list", component: () => import('./role/index.vue')},
                { path:"setPermission",meta: { title: 'Action.SetPermission',hideInMenu:true }, name:"role.setPermission", component: () => import('./role/component/set-permission.vue')},
            ] 
        },
        { 
            path: 'tenant',  meta: { title: 'Tenants',access:['Pages.Tenants'] }, name: 'tenant', component: () => import('./tenant/index.vue')
        },
        {
            path: 'customer', meta: { title: 'app.Customer', access: ['RIMS.Customer'], icon: '', defaultChild: 'customer.list' },
            name: 'customer', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.Customer', access: ['RIMS.Customer'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customer.list', component: () => import('./customer/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.Customer.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customer.add', component: () => import('./customer/component/create-customer.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.Customer.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customer.edit', component: () => import('./customer/component/edit-customer.vue'),
                },        
            ]
        },
        {
            path: 'sender', meta: { title: 'app.Sender', access: ['RIMS.Sender'], icon: '', defaultChild: 'sender.list' },
            name: 'sender', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.Sender', access: ['RIMS.Sender'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'sender.list', component: () => import('./sender/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.Sender.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'sender.add', component: () => import('./sender/component/create-sender.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.Sender.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'sender.edit', component: () => import('./sender/component/edit-sender.vue'),
                },        
            ]
        },
        {
            path: 'productname', meta: { title: 'app.ProductName', access: ['RIMS.ProductName'], icon: '', defaultChild: 'productname.list' },
            name: 'productname', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.ProductName', access: ['RIMS.ProductName'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'productname.list', component: () => import('./productname/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.ProductName.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'productname.add', component: () => import('./productname/component/create-product-name.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.ProductName.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'productname.edit', component: () => import('./productname/component/edit-product-name.vue'),
                },        
            ]
        },
        {
            path: 'factory', meta: { title: 'app.Factory', access: ['RIMS.Factory'], icon: '', defaultChild: 'factory.list' },
            name: 'factory', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.Factory', access: ['RIMS.Factory'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'factory.list', component: () => import('./factory/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.Factory.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'factory.add', component: () => import('./factory/component/create-factory.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.Factory.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'factory.edit', component: () => import('./factory/component/edit-factory.vue'),
                },        
            ]
        },
        {
            path: 'logistics', meta: { title: 'app.Logistics', access: ['RIMS.Logistics'], icon: '', defaultChild: 'logistics.list' },
            name: 'logistics', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.Logistics', access: ['RIMS.Logistics'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'logistics.list', component: () => import('./logistics/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.Logistics.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'logistics.add', component: () => import('./logistics/component/create-logistics.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.Logistics.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'logistics.edit', component: () => import('./logistics/component/edit-logistics.vue'),
                },        
            ]
        },
        {
            path: 'customersystemcode', meta: { title: 'app.SystemCode', access: ['RIMS.CustomerSystemCode'], icon: '', defaultChild: 'customersystemcode.list' },
            name: 'customersystemcode', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.SystemCode', access: ['RIMS.CustomerSystemCode'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customersystemcode.list', component: () => import('./customersystemcode/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.CustomerSystemCode.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customersystemcode.add', component: () => import('./customersystemcode/component/create-customer-systemcode.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.CustomerSystemCode.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customersystemcode.edit', component: () => import('./customersystemcode/component/edit-customer-systemcode.vue'),
                },        
            ]
        },
        {
            path: 'estimatedexchangerate', meta: { title: 'app.EstimatedExchangeRate', access: ['RIMS.EstimatedExchangeRate'], icon: '', defaultChild: 'estimatedexchangerate.list' },
            name: 'estimatedexchangerate', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.EstimatedExchangeRate', access: ['RIMS.EstimatedExchangeRate'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'estimatedexchangerate.list', component: () => import('./estimatedexchangerate/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.EstimatedExchangeRate.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'estimatedexchangerate.add', component: () => import('./estimatedexchangerate/component/create-estimated-exchange-rate.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.EstimatedExchangeRate.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'estimatedexchangerate.edit', component: () => import('./estimatedexchangerate/component/edit-estimated-exchange-rate.vue'),
                },        
            ]
        },
        {
            path: 'customsdeclarationelement', meta: { title: 'app.CustomsDeclarationElement', access: ['RIMS.CustomsDeclarationElement'], icon: '', defaultChild: 'customsdeclarationelement.list' },
            name: 'customsdeclarationelement', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.CustomsDeclarationElement', access: ['RIMS.CustomsDeclarationElement'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customsdeclarationelement.list', component: () => import('./customsdeclarationelement/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.CustomsDeclarationElement.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customsdeclarationelement.add', component: () => import('./customsdeclarationelement/component/create-customs-declaration-element.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.CustomsDeclarationElement.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'customsdeclarationelement.edit', component: () => import('./customsdeclarationelement/component/edit-customs-declaration-element.vue'),
                },        
            ]
        },
        {
            path: 'userassignment', meta: { title: 'app.UserAssignment', access: ['RIMS.UserAssignment'], icon: '', defaultChild: 'userassignment.list' },
            name: 'userassignment', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.UserAssignment', access: ['RIMS.UserAssignment'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'userassignment.list', component: () => import('./userassignment/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.UserAssignment.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'userassignment.add', component: () => import('./userassignment/component/create-user-assignment.vue'),
                },  
                {
                    path: 'return', meta: { title: 'app.UserAssignment.Return', access: ['RIMS.UserAssignment.Return'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'userassignment.return', component: () => import('./userassignment/component/return-user-assignment.vue'),
                },     
            ]
        },
    ]
}]

export default appRouters